export default __webpack_public_path__ + "static/media/cover.289bee5f.jpeg";